var OcapiUrlConstants = /** @class */ (function () {
    function OcapiUrlConstants() {
    }
    OcapiUrlConstants.OCAPI_SALES_SERVICE = '/ocapi/public/api/sales-service/v1';
    OcapiUrlConstants.OCAPI_SALES_SERVICE_V2 = '/ocapi/public/api/sales-service/v2';
    OcapiUrlConstants.OCAPI_PRODUCT_SERVICE = '/ocapi/public/api/product-service/v1';
    OcapiUrlConstants.OCAPI_ADAPTOR_ACTION = '/ocapi-adaptor/action/public';
    OcapiUrlConstants.OCAPI_ADAPTOR = '/ocapi-adaptor/public';
    OcapiUrlConstants.OCAPI_ADAPTOR_QUERY = '/ocapi-adaptor/query/public';
    return OcapiUrlConstants;
}());
export { OcapiUrlConstants };
